import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { FormattedMessage } from 'react-intl';

import messages from './headerBar.messages';
import { Container, Content, LogoImg, LogoLink, BackLink, ArrowIcon } from './headerBar.styles';
import { Theme } from '../../../modules/headerBar/themes';
import { WindowListener } from '../windowListener/windowListener.component';
import { getBodyScroll } from '../../utils/scroll';
import { Navigation } from './navigation';
import { Breakpoints, isTabletOrBelow } from '../../../theme/media';
import { renderWhenTrue } from '../../utils/rendering';
import { HiddenOnPlatform } from '../hiddenOnPlatform';
import { ICON_ARROW_LEFT } from '../icon';

export class HeaderBar extends PureComponent {
  static propTypes = {
    theme: PropTypes.oneOf([Theme.LIGHT, Theme.FILLED, Theme.HIDDEN]),
    experienceId: PropTypes.string,
    currentHomeRoute: PropTypes.string,
    isSignedIn: PropTypes.bool,
    isKioskMode: PropTypes.bool,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    theme: Theme.LIGHT,
  };

  state = {
    isScrollToTop: true,
    isHamburgerOpen: false,
  };

  componentDidMount() {
    this.handleScroll();
  }

  componentDidUpdate(prevProps) {
    this.handleScroll();

    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleCloseHamburger();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updateTimeout);
  }

  activeTheme = () => (!this.state.isScrollToTop ? Theme.FILLED : this.props.theme);

  isVisible = () => this.props.theme !== Theme.HIDDEN;

  updateTimeout = null;

  handleNavigationClick = () => {
    if (isTabletOrBelow()) {
      this.setState(({ isHamburgerOpen }) => ({ isHamburgerOpen: !isHamburgerOpen }));
    }
  };

  handleScroll = () => {
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => this.setState({ isScrollToTop: getBodyScroll() <= 0 }));
  };

  handleCloseHamburger = () => this.setState({ isHamburgerOpen: false });

  renderBackButton = () => (
    <HiddenOnPlatform below={Breakpoints.TABLET}>
      <BackLink to={this.props.currentHomeRoute}>
        <FormattedMessage {...messages.back} />
        <ArrowIcon stroked name={ICON_ARROW_LEFT} />
      </BackLink>
    </HiddenOnPlatform>
  );

  render() {
    return (
      <ThemeProvider
        theme={{
          isVisible: this.isVisible(),
          headerTheme: this.activeTheme(),
          isHamburgerOpen: this.state.isHamburgerOpen,
          isUserAnonymous: !this.props.isSignedIn,
        }}
      >
        <Container>
          <WindowListener eventType="scroll" onEvent={this.handleScroll} throttle={250} />
          <WindowListener eventType="resize" onEvent={this.handleCloseHamburger} throttle={250} />
          <Content>
            <LogoLink to={this.props.currentHomeRoute}>
              <LogoImg />
            </LogoLink>

            {renderWhenTrue(() => (
              <Navigation isOpened={this.state.isHamburgerOpen} onItemClick={this.handleNavigationClick} />
            ))(!this.props.isKioskMode)}

            {renderWhenTrue(this.renderBackButton)(this.props.isKioskMode && !!this.props.experienceId)}
          </Content>
        </Container>
      </ThemeProvider>
    );
  }
}
